// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3B6h_","createBtn":"styles_createBtn__4EGC_","studyBtn":"styles_studyBtn__2nvTN"};